import React from 'react';
import PropTypes from 'prop-types';
import PopConfirm from '@omilia/popconfirm';

import Spinner from 'components/Spinner';
import './style.scss';

const TrashPopConfirm = ({ className, text, place, isLoading, onDelete }) => {
  if (isLoading) {
    return <Spinner isBlue styleName="spinner" />;
  }
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/anchor-is-valid */
  return (
    <PopConfirm
      confirmLabel="Yes"
      declineLabel="Cancel"
      placement={place}
      title={text}
      onConfirm={onDelete}
    >
      <a className={className} data-test="trash" styleName="trash">
        <i className="icon-recycle-bin" />
      </a>
    </PopConfirm>
  );
};

TrashPopConfirm.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  place: PropTypes.string,
  text: PropTypes.string,
  onDelete: PropTypes.func,
};

TrashPopConfirm.defaultProps = {
  text: '',
  className: '',
  place: 'left',
  isLoading: false,
};

export default TrashPopConfirm;
